import React from "react";
import { usePlayer } from "../context/PlayerContext";
import { Waveform } from "./Waveform";
import { Play, Pause, X } from "lucide-react";

export function AudioBar() {
  const { track, playing, progress, togglePlay, seek, close } = usePlayer();
  if (!track) return null;
  return (
    <div
      className="fixed left-0 right-0 z-40 glass border-t border-violet-900/40 shadow-2xl bottom-16 sm:bottom-0"
      data-testid="global-audio-player"
    >
      <div
        className="h-1 bg-zinc-800 cursor-pointer sm:hidden"
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          seek(((e.clientX - rect.left) / rect.width) * 100);
        }}
        data-testid="audio-progress-bar"
      >
        <div className="h-full bg-gradient-to-r from-violet-500 to-purple-500" style={{ width: `${progress}%` }} />
      </div>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2.5 flex items-center gap-3">
        <button
          onClick={togglePlay}
          data-testid="audio-player-play-pause-button"
          className="w-11 h-11 rounded-full bg-gradient-to-r from-violet-600 to-purple-600 flex items-center justify-center text-white shrink-0 hover:scale-105 transition-transform"
        >
          {playing ? <Pause size={18} fill="white" /> : <Play size={18} fill="white" className="ml-0.5" />}
        </button>
        {track.cover ? (
          <img src={track.cover} alt="" className="w-11 h-11 rounded-lg object-cover shrink-0 hidden xs:block" />
        ) : null}
        <div className="min-w-0 flex-1 sm:flex-none sm:w-52">
          <p className="font-display font-semibold text-sm truncate text-white">{track.title}</p>
          <p className="text-xs text-zinc-400 truncate font-mono">{track.subtitle}</p>
        </div>
        <Waveform trackId={track.id} progress={progress} playing={playing} onSeek={seek}
          className="hidden sm:flex flex-1 mx-3" bars={64} />
        {playing && (
          <div className="bar-eq text-violet-400 mr-1 sm:hidden"><span></span><span></span><span></span><span></span></div>
        )}
        <button onClick={close} className="text-zinc-500 hover:text-white p-2" data-testid="audio-close-button">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
